import React, { useEffect, useState } from "react";
import { isEmpty, ObjectIsempty } from "../lib/isEmpty";
import { addNewToken, addTrendingSuggestedPair, deleteTrendingSuggestedPair, updateTrendingSuggestedPairs } from "../actions/currency";
import { UseToken } from "../Hooks/useWeb3";
import Select from "react-select";
import { Modal } from "react-bootstrap";
import { editSingleToken } from "../actions/currency";
import toast from "react-hot-toast";
import { deleteSingleToken } from "../actions/currency";

function FormInput({ label, name, placeholder, value, onChange, readOnly = false, error }) {
    return (
        <div className="rp_singleinput_holder mb-3">
            <p className="rp_label mb-2">{label}</p>
            <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                <input
                    type="text"
                    name={name}
                    className="rp_singleInput flex-grow-1"
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    readOnly={readOnly}
                />

            </div>
            {error && <span className="text-danger text-left block">{error}</span>}
        </div>
    );
}

export const AddRankingPairModal = ({ show, handleClose, record, getTokens }) => {
    const [formvalue, setFormvalue] = useState({});
    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, type, value, checked } = e.target;
        const updatedValue = type === "checkbox" ? checked : value;

        const updatedForm = { ...formvalue, [name]: updatedValue };
        setFormvalue(updatedForm);
        setErrors(validate(updatedForm));
    };

    const validate = (values) => {
        const errors = {};

        if (!values.pairAddress?.trim()) errors.pairAddress = "Pair pairAddress is required";
        if (!values.symbol?.trim()) errors.symbol = "Pair Symbol is required";
        if (!values.baseTokenSymbol?.trim()) errors.baseTokenSymbol = "Base Token Symbol is required";
        if (!values.quoteTokenSymbol?.trim()) errors.quoteTokenSymbol = "Quote Token Symbol is required";
        // if (!values.baseTokenName?.trim()) errors.baseTokenName = "Base Token Name is required";
        // if (!values.quoteTokenName?.trim()) errors.quoteTokenName = "Quote Token Name is required";

        if (values.baseTokenDecimals === "" || isNaN(values.baseTokenDecimals)) {
            errors.baseTokenDecimals = "Base Token Decimals must be a number";
        }

        if (values.quoteTokenDecimals === "" || isNaN(values.quoteTokenDecimals)) {
            errors.quoteTokenDecimals = "Quote Token Decimals must be a number";
        }

        if (!values.chainId || isNaN(values.chainId)) {
            errors.chainId = "Valid Chain ID is required";
        }

        if (!values.type?.trim()) errors.type = "Contract Type is required";


        return errors;
    };

    const handleSubmit = async () => {
        const validationErrors = validate(formvalue);
        setErrors(validationErrors);
        if (Object.keys(validationErrors).length > 0) return;

        try {
            const payload = {
                pairAddress: formvalue.pairAddress,
                symbol: formvalue.symbol,
                chainId: Number(formvalue.chainId),
                // name: `${formvalue.baseTokenName} / ${formvalue.quoteTokenName}`,
                address: formvalue.baseTokenAddress,
                baseTokenSymbol: formvalue.baseTokenSymbol,
                quoteTokenSymbol: formvalue.quoteTokenSymbol,
                // baseTokenName: formvalue.baseTokenName,
                quoteTokenName: formvalue.quoteTokenName,
                baseTokenDecimals: Number(formvalue.baseTokenDecimals),
                quoteTokenDecimals: Number(formvalue.quoteTokenDecimals),
                type: formvalue.type,
                isAdminApproved: formvalue.isAdminApproved ?? false,
                logoImg: formvalue.logoImg
            };

            const { status } = await addTrendingSuggestedPair(payload);

            if (status === "success") {
                toast.success("Pair added successfully!");
                handleClose();
                getTokens();
            } else {
                toast.error("Failed to add pair.");
            }
        } catch (error) {
            toast.error("Error while adding pair.");
            console.error("AddPair Error:", error);
        }
    };

    return (
        <Modal
            centered
            className="cmn_modal"
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Body>
                <div className="cmn_modal_header d-flex justify-content-between align-items-center">
                    <p className="cmn_modal_title">Add Ranking Pair</p>
                    <button className="cmn_modal_closer" onClick={handleClose}>
                        <i className="fa-solid fa-xmark" />
                    </button>
                </div>

                <div className="mt-4">
                    <FormInput label="Pair Address" name="pairAddress" placeholder={"Pair Address"} value={formvalue.pairAddress || ""} onChange={handleChange} error={errors.pairAddress} />

                    <FormInput label="Pair Symbol" name="symbol" placeholder={"Pair Symbol"} value={formvalue.symbol || ""} onChange={handleChange} error={errors.symbol} />

                    {/* <FormInput label="Base Token Name" name="baseTokenName" placeholder={"Base Token Name"} value={formvalue.baseTokenName || ""} onChange={handleChange} error={errors.baseTokenName} />

                    <FormInput label="Base Token Symbol" name="baseTokenSymbol" placeholder={"Base Token Symbol"} value={formvalue.baseTokenSymbol || ""} onChange={handleChange} error={errors.baseTokenSymbol} /> */}

                    <FormInput label="Base Token Address" name="baseTokenAddress" placeholder={"Base Token Address"} value={formvalue.baseTokenAddress || ""} onChange={handleChange} />

                    <FormInput label="Base Token Decimals" name="baseTokenDecimals" placeholder={"Base Token Decimals"} value={formvalue.baseTokenDecimals || ""} onChange={handleChange} error={errors.baseTokenDecimals} />

                    <FormInput label="Quote Token Name" name="quoteTokenName" placeholder={"Quote Token Name"} value={formvalue.quoteTokenName || ""} onChange={handleChange} error={errors.quoteTokenName} />

                    <FormInput label="Quote Token Symbol" name="quoteTokenSymbol" placeholder={"Quote Token Symbol"} value={formvalue.quoteTokenSymbol || ""} onChange={handleChange} error={errors.quoteTokenSymbol} />

                    <FormInput label="Quote Token Address" name="quoteTokenAddress" placeholder={"Quote Token Address"} value={formvalue.quoteTokenAddress || ""} onChange={handleChange} />

                    <FormInput label="Quote Token Decimals" name="quoteTokenDecimals" placeholder={"Quote Token Decimals"} value={formvalue.quoteTokenDecimals || ""} onChange={handleChange} error={errors.quoteTokenDecimals} />

                    <FormInput label="Chain ID" name="chainId" placeholder={"Chain ID"} value={formvalue.chainId || ""} onChange={handleChange} error={errors.chainId} />

                    <FormInput label="Type" name="type" placeholder={"Type"} value={formvalue.type || ""} onChange={handleChange} error={errors.type} />

                    <FormInput label="Logo Image" name="logoImg" placeholder={"Logo Image"} value={formvalue.logoImg || ""} onChange={handleChange} />

                    <div className="rp_singleinput_holder mb-3">
                        <div className="rp_input_holder py-2 px-3 d-flex justify-content-between align-items-center gap-2">
                            <p className="rp_label mb-0">Show the Token</p>
                            <div className="showAndHideToggle">
                                <input type="checkbox" name="isAdminApproved" checked={formvalue.isAdminApproved || false} onChange={handleChange} />
                                <label></label>
                            </div>
                        </div>
                    </div>

                    <button className="orange_small_primary mt-3" onClick={handleSubmit}>
                        Submit
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export const EditRankingPairModal = ({ show, handleClose, record, getTokens }) => {

    const [formvalue, setFormvalue] = useState({});
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (record) {

            const initial = {
                _id: record._id,
                chainId: record?.chain,
                symbol: record.tokenIn?.symbol + "/" + record.tokenOut?.symbol,
                type: record.sell?.type,
                pairAddress: record.buyDetails?.pool,
                isAdminApproved: record.isAdminApproved ?? false,
                baseToken: {
                    address: record.tokenIn?.address,
                    symbol: record.tokenIn?.symbol,
                    //     name: record.tokenIn?.name,
                    decimals: record.tokenIn?.decimals,
                },
                quoteToken: {
                    address: record.tokenOut?.address,
                    symbol: record.tokenOut?.symbol,
                    //     name: record.tokenOut?.name,
                    decimals: record.tokenOut?.decimals,
                },

            };
            setFormvalue(initial);
        }
    }, [record]);

    const handleChange = (e) => {
        const { name, type, value, checked } = e.target;
        const updatedValue = type === "checkbox" ? checked : value;

        let updatedForm = { ...formvalue };

        if (name.startsWith("baseToken.") || name.startsWith("quoteToken.")) {
            const [tokenKey, field] = name.split(".");
            updatedForm[tokenKey] = {
                ...formvalue[tokenKey],
                [field]: updatedValue,
            };
        } else {
            updatedForm[name] = updatedValue;
        }

        setFormvalue(updatedForm);
        setErrors(validation(updatedForm));
    };

    const validation = (form) => {
        const errs = {};

        if (!form.pairAddress) errs.pairAddress = "Pair pairAddress is required";
        if (!form.symbol) errs.symbol = "Pair Symbol is required";
        if (!form.type) errs.type = "Type is required";

        const b = form.baseToken || {};
        const q = form.quoteToken || {};

        // if (!b.name) errs.baseTokenName = "Base Token Name is required";
        // if (!b.symbol) errs.baseTokenSymbol = "Base Token Symbol is required";
        // if (!q.name) errs.quoteTokenName = "Quote Token Name is required";
        if (!q.symbol) errs.quoteTokenSymbol = "Quote Token Symbol is required";
        if (isNaN(b.decimals)) errs.baseTokenDecimals = "Base Token Decimals must be a number";
        if (isNaN(q.decimals)) errs.quoteTokenDecimals = "Quote Token Decimals must be a number";

        return errs;
    };

    const handleSubmit = async () => {
        const payload = {
            _id: formvalue?._id,
            symbol: formvalue?.symbol,
            chainId: formvalue?.chainId,
            type: formvalue?.type,
            isAdminApproved: formvalue.isAdminApproved,
            pairAddress: formvalue.pairAddress,
            // logoImg: formvalue.logoImg,
            tokenIn: {
                address: formvalue.baseToken?.address,
                symbol: formvalue.baseToken?.symbol,
                // name: formvalue.baseToken?.name,
                decimals: formvalue.baseToken?.decimals,
            },
            tokenOut: {
                address: formvalue.quoteToken?.address,
                symbol: formvalue.quoteToken?.symbol,
                // name: formvalue.quoteToken?.name,
                decimals: formvalue.quoteToken?.decimals,
            },
        };

        const validationErrors = validation(formvalue);
        console.log('payload-------', validationErrors)
        setErrors(validationErrors);
        if (Object.keys(validationErrors).length > 0) return;

        try {

            const { status } = await updateTrendingSuggestedPairs(payload);
            if (status === "success") {
                toast.success("Pair updated successfully!");
                getTokens();
                handleClose();
            } else {
                toast.error("Failed to update pair.");
            }
        } catch (err) {
            console.error("Error updating pair:", err);
            toast.error("Something went wrong.");
        }
    };

    return (
        <Modal centered className="cmn_modal" show={show} onHide={handleClose} backdrop="static" keyboard={false}>
            <Modal.Body>
                <div className="cmn_modal_header d-flex justify-content-between align-items-center">
                    <p className="cmn_modal_title">Edit Ranking Pair</p>
                    <button className="cmn_modal_closer rounded-5" onClick={handleClose}>
                        <i className="fa-solid fa-xmark" />
                    </button>
                </div>

                <div className="mt-4">
                    {/* Read-only fields */}
                    <FormInput label="Pair Address" placeholder={"Pair Address"} value={formvalue.pairAddress} readOnly error={errors.pairAddress} />
                    <FormInput label="Base Token Address" placeholder={"Base Token Address"} value={formvalue.baseToken?.address} readOnly />
                    <FormInput label="Quote Token Address" placeholder={"Quote Token Address"} value={formvalue.quoteToken?.address} readOnly />

                    {/* Editable fields */}
                    <FormInput label="Pair Symbol" name="symbol" placeholder={"Pair Symbol"} value={formvalue.symbol} onChange={handleChange} error={errors.symbol} />

                    <FormInput label="Base Token Symbol" name="baseToken.symbol" placeholder={"Base Token Symbol"} value={formvalue.baseToken?.symbol} onChange={handleChange} error={errors.baseTokenSymbol} />
                    <FormInput label="Quote Token Symbol" name="quoteToken.symbol" placeholder={"Quote Token Symbol"} value={formvalue.quoteToken?.symbol} onChange={handleChange} error={errors.quoteTokenSymbol} />

                    {/*  <FormInput label="Base Token Name" name="baseToken.name" placeholder={"Base Token Name"} value={formvalue.baseToken?.name} onChange={handleChange} error={errors.baseTokenName} />
                    <FormInput label="Quote Token Name" name="quoteToken.name" placeholder={"Quote Token Name"} value={formvalue.quoteToken?.name} onChange={handleChange} error={errors.quoteTokenName} />
                    */}

                    <FormInput label="Base Token Decimals" name="baseToken.decimals" placeholder={"Base Token Decimals"} value={formvalue.baseToken?.decimals} onChange={handleChange} error={errors.baseTokenDecimals} />
                    <FormInput label="Quote Token Decimals" name="quoteToken.decimals" placeholder={"Quote Token Decimals"} value={formvalue.quoteToken?.decimals} onChange={handleChange} error={errors.quoteTokenDecimals} />

                    <FormInput label="Chain ID" placeholder={"Chain ID"} value={formvalue.chainId} readOnly />
                    <FormInput label="Type" name="type" placeholder={"Pair Address"} value={formvalue.type} onChange={handleChange} error={errors.type} />
                    {/* <FormInput label="logo Image" name="logoImg" placeholder={"logo Image"} value={formvalue.logoImg} onChange={handleChange} /> */}

                    {/* Toggle */}
                    <div className="rp_singleinput_holder mb-3">
                        <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-between align-items-center gap-2">
                            <p className="rp_label mb-0">Show the Token</p>
                            <div className="showAndHideToggle">
                                <input type="checkbox" name="isAdminApproved" checked={formvalue.isAdminApproved} onChange={handleChange} />
                                <label></label>
                            </div>
                        </div>
                    </div>

                    <button className="orange_small_primary mt-3" onClick={handleSubmit}>
                        Submit
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export const DeleteRankingPairModal = ({ show, handleClose, record, getTokens }) => {
    const deleteToken = async () => {
        try {
            if (!record) {
                toast.error("No token selected for deletion.");
                return;
            }

            const { status, message } = await deleteTrendingSuggestedPair({ record });

            if (status === "success") {
                toast.success("Token Deleted Successfully");
                getTokens(); // Refresh list
            } else {
                toast.error(message || "Token Deletion Failed");
            }
        } catch (err) {
            console.error("deletePair_err", err);
            toast.error("Unexpected error while deleting token.");
        }
    };

    const handleConfirmDelete = () => {
        deleteToken();
        handleClose();
    };

    return (
        <Modal centered className="cmn_modal" show={show} onHide={handleClose} backdrop="static" keyboard={false}>
            <Modal.Body>
                <div className="cmn_modal_header d-flex justify-content-between align-items-center">
                    <p className="cmn_modal_title">Delete Pairs</p>
                    <button className="cmn_modal_closer rounded-5" onClick={handleClose}>
                        <i className="fa-solid fa-xmark" />
                    </button>
                </div>

                <div className="mt-3">
                    <p className="dash_graymed_text">
                        Are you sure you want to delete this pair?
                    </p>

                    <button className="orange_small_primary mt-4" onClick={handleConfirmDelete} >
                        Confirm Delete
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

